/* with love from shopstory */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const EasyblocksCanvasContext = /*#__PURE__*/React.createContext(null);
const EasyblocksCanvasProvider = _ref => {
  let {
    children,
    components
  } = _ref;
  const [state, setState] = React.useState(null);
  React.useEffect(() => {
    const handler = event => {
      if (event.data.type === "@easyblocks/canvas-data") {
        const data = JSON.parse(event.data.data);
        setState(prevState => ({
          ...prevState,
          ...data,
          components
        }));
      }
    };
    window.addEventListener("message", handler);
    return () => {
      window.removeEventListener("message", handler);
    };
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(EasyblocksCanvasContext.Provider, {
    value: state
  }, children);
};
const useEasyblocksCanvasContext = () => {
  return React.useContext(EasyblocksCanvasContext);
};

exports.EasyblocksCanvasProvider = EasyblocksCanvasProvider;
exports.useEasyblocksCanvasContext = useEasyblocksCanvasContext;
